import React from 'react';
import { Badge } from '../components/ui/badge';
import { Clock, Wrench, CheckCircle2, XCircle, AlertCircle, Ban } from 'lucide-react';
import { PRACTICE_STATUS, PRACTICE_STATUS_LABELS } from '../lib/constants';

const STATUS_CONFIG = {
  [PRACTICE_STATUS.IN_ATTESA_PRESA_IN_CARICO]: {
    className: 'bg-slate-50 text-slate-800 border-slate-200',
    icon: Clock,
  },
  [PRACTICE_STATUS.IN_LAVORAZIONE]: {
    className: 'bg-blue-50 text-blue-900 border-blue-200',
    icon: Wrench,
  },
  [PRACTICE_STATUS.DA_INTEGRARE]: {
    className: 'bg-amber-50 text-amber-900 border-amber-200',
    icon: AlertCircle,
  },
  [PRACTICE_STATUS.COMPLETATA_IN_COMITATO]: {
    className: 'bg-emerald-50 text-emerald-900 border-emerald-200',
    icon: CheckCircle2,
  },
  [PRACTICE_STATUS.RIFIUTATA]: {
    className: 'bg-rose-50 text-rose-900 border-rose-200',
    icon: XCircle,
  },
  [PRACTICE_STATUS.KO]: {
    className: 'bg-red-100 text-red-900 border-red-300',
    icon: Ban,
  },
};

export const StatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status];
  const Icon = config?.icon;
  const label = PRACTICE_STATUS_LABELS[status] || status;

  return (
    <Badge
      className={`${config?.className} flex items-center gap-1.5`}
      data-testid="practice-status-badge"
    >
      {Icon && <Icon className="h-3.5 w-3.5" />}
      {label}
    </Badge>
  );
};
